<div class="cto-block">
  <div [ngSwitch]="contract?.status">
    <ng-template ngSwitchCase="1">
      <svg-icon key="time" class="grey-icon"></svg-icon>
    </ng-template>
    <ng-template ngSwitchCase="5">
      <svg-icon key="time" class="grey-icon"></svg-icon>
    </ng-template>
    <ng-template ngSwitchCase="2">
      <svg-icon key="cto"></svg-icon>
    </ng-template>
    <ng-template ngSwitchDefault>
      <svg-icon key="block" class="grey-icon"></svg-icon>
    </ng-template>
  </div>

  <span class="cto-title" data-qa="cto-name">{{ contract?.cto?.name }}</span>
  <div
    class="retail-place__arrow"
    data-qa-button="expand-data"
    (click)="isFullInfoVisible = !isFullInfoVisible"
  >
    <svg-icon
      [key]="isFullInfoVisible ? 'expand-less' : 'expand-more'"
      class="grey-icon"
    ></svg-icon>
  </div>
</div>

<div *ngIf="isFullInfoVisible" class="hidden-block grey-text" data-qa-block="cto-info">
  <div class="hidden-block-line" data-qa="address">
    {{ 'cto.info.address' | translate }}
    {{ contract?.cto?.address }}
  </div>

  <div class="hidden-block-line" data-qa="iin-bin">
    {{ 'cto.info.iin' | translate }}
    {{ contract?.cto?.iinOrBin }}
  </div>

  <div class="hidden-block-line" data-qa="contacts">
    {{ 'cto.info.phone' | translate }}
    {{ contract?.cto?.contacts }}
  </div>

  <div *ngIf="contract?.permissions?.length" class="hidden-block-line" data-qa="modules">
    {{ 'cto.system.modules' | translate }}
    <ng-container *ngFor="let permission of contract?.permissions; last as isLast">
      {{ permission | translate }}<ng-container *ngIf="!isLast">,</ng-container>
    </ng-container>
  </div>

  <div class="hidden-block-line" data-qa-block="kkm-models">
    <div translate data-qa="kkm-models-title">cto.info.kkm.models</div>
    <div class="hidden-block-line" data-qa="kkm-models">
      <ng-container
        *ngFor="let model of getServicedModels(contract?.cto?.servicedModels); last as isLast"
      >
        {{ model }}<ng-container *ngIf="!isLast">,</ng-container>
      </ng-container>
    </div>
  </div>
</div>
